import { ReactElement } from "react";
import { Toaster } from "react-hot-toast";
import { Switch } from "react-router-dom";

import Layout from "./components/Layout";

import { UserContextProvider } from "./context/UserContext";
import { PrefContextProvider } from "./context/PreferencesContext";
import { NotificationContextProvider } from "./context/NotificationContext";
import { LocationContextProvider } from "./context/LocationContext";
import { SerialProvider } from "./context/SerialProvider";
import { FeatureFlagProvider } from "./context/FeatureFlagProvider";

import ProtectedRoute from "./routing/components/ProtectedRoute";
import { RouteConfig } from "./routing/types";
import { routeRegistry } from "./routing/routes/registry";

const App = (): ReactElement => {
  const routes: RouteConfig[] = Object.values(routeRegistry);

  return (
    <UserContextProvider>
      <FeatureFlagProvider>
        <PrefContextProvider>
          <NotificationContextProvider>
            <LocationContextProvider>
              <SerialProvider>
                <Layout>
                  <Switch>
                    {routes.map((route, i) => (
                      <ProtectedRoute
                        exact={route.path === "/"}
                        key={route.path}
                        path={route.path}
                        component={route.component}
                        restrictedToRoles={route.allowedRoles}
                        featureFlag={route.featureFlag}
                        featureFlagBypassRoles={route.featureFlagBypassRoles}
                      />
                    ))}
                  </Switch>
                  <Toaster position="top-right" />
                </Layout>
              </SerialProvider>
            </LocationContextProvider>
          </NotificationContextProvider>
        </PrefContextProvider>
      </FeatureFlagProvider>
    </UserContextProvider>
  );
};

export default App;
